export enum ECurrency {
    USD = "USD",  // United States Dollar
    INR = "INR", // Indian Rupee
}